import { render, staticRenderFns } from "./TheEndScreen.vue?vue&type=template&id=451bcfd6&"
import script from "./TheEndScreen.vue?vue&type=script&lang=js&"
export * from "./TheEndScreen.vue?vue&type=script&lang=js&"
import style0 from "./TheEndScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports